
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface DeactivationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
}

export const DeactivationDialog = ({
  open,
  onOpenChange,
  onConfirm,
}: DeactivationDialogProps) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Are you sure you want to deactivate your account?</AlertDialogTitle>
          <AlertDialogDescription className="space-y-3">
            <p>
              Deactivating your account will:
            </p>
            <ul className="list-disc pl-4 space-y-1">
              <li>Sign you out immediately</li>
              <li>Prevent you from accessing your account and data</li>
              <li>Allow you to reactivate your account within 7 days</li>
            </ul>
            <p className="font-medium mt-4">
              After 7 days, you'll need to contact hello@superalts.ca to reactivate your account.
            </p>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Cancel</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            variant="destructive"
          >
            Deactivate Account
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
